// extracted by mini-css-extract-plugin
export default {"th":"src_th__9piqu","control":"src_control__15diD","icon":"src_icon__sLJJa"};